export default {
  type: null,
  message: null,
  show: false,
};
